import React from "react";
import { Layout, message, Row, Col, Radio, Input, Modal, Menu } from "antd";
import TableWrapper from "../../elements/TableWrapper";

import MiCompAPI from "../../../util/api";
import ApproveDocumentDrawer from "../../User/ApproveDocumentDrawer";
import moment from "moment";
const { Content } = Layout;
class Compliance extends React.Component {
  com_columns = [
    {
      title: "License Number",
      dataIndex: "license_No",
      sorter: (a, b) => a.license_No.localeCompare(b.license_No),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Document Name",
      dataIndex: "docName",
      sorter: (a, b) => a.docName.localeCompare(b.docName),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Submit Date",
      dataIndex: "submit_Date",
      sorter: (a, b) => new Date(a.submit_Date) - new Date(b.submit_Date),
      render: (text, record) =>
        record["submit_Date"] !== null && record["submit_Date"] !== ""
          ? moment(record["submit_Date"]).format("MM/DD/YYYY")
          : "",
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Date Approved",
      dataIndex: "date_Approved",
      sorter: (a, b) => new Date(a.date_Approved) - new Date(b.date_Approved),
      render: (text, record) =>
        record["date_Approved"] !== null && record["date_Approved"] !== ""
          ? moment(record["date_Approved"]).format("MM/DD/YYYY")
          : "",
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Effective Date",
      dataIndex: "effective_Date",
      sorter: (a, b) => new Date(a.effective_Date) - new Date(b.effective_Date),
      render: (text, record) =>
        record["effective_Date"] !== null && record["effective_Date"] !== ""
          ? moment(record["effective_Date"]).format("MM/DD/YYYY")
          : "",
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Termination Date",
      dataIndex: "termination_Date",
      sorter: (a, b) =>
        new Date(a.termination_Date) - new Date(b.termination_Date),
      render: (text, record) =>
        record["termination_Date"] !== null && record["termination_Date"] !== ""
          ? moment(record["termination_Date"]).format("MM/DD/YYYY")
          : "",
      sortDirections: ["descend", "ascend"],
    },
  ];

  DOCUMENT_COLUMNS = [
    {
      title: "Document Type",
      dataIndex: "document_type_name",
      sorter: (a, b) =>
        a.document_type_name.localeCompare(b.document_type_name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Submit Date",
      dataIndex: "submit_date",
      render: (text, record) =>
        record["submit_date"] !== null && record["submit_date"] !== ""
          ? moment(record["submit_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.submit_date) - new Date(b.submit_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Effective Date",
      dataIndex: "effective_date",
      render: (text, record) =>
        record["effective_date"] !== null && record["effective_date"] !== ""
          ? moment(record["effective_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.effective_date) - new Date(b.effective_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Termination Date",
      dataIndex: "termination_date",
      render: (text, record) =>
        record["termination_date"] !== null && record["termination_date"] !== ""
          ? moment(record["termination_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) =>
        new Date(a.termination_date) - new Date(b.termination_date),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Renewal Date",
      dataIndex: "renewal_date",
      render: (text, record) =>
        record["renewal_date"] !== null && record["renewal_date"] !== ""
          ? moment(record["renewal_date"]).format("MM/DD/YYYY")
          : "",
      sorter: (a, b) => new Date(a.renewal_date) - new Date(b.renewal_date),
      sortDirections: ["descend", "ascend"],
    },
  ];
  agency_columns = [
    {
      title: "Agency Name",
      dataIndex: "name",
      sorter: (a, b) => a.agency_Name.localeCompare(b.agency_Name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Primary Contact First Name",
      dataIndex: "first_Name",
      sorter: (a, b) => a.first_Name.localeCompare(b.first_Name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Primary Contact Last Name",
      dataIndex: "last_Name",
      sorter: (a, b) => a.last_Name.localeCompare(b.last_Name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Primary Contact Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Primary Contact Phone",
      dataIndex: "phone",
      render: (text, record) =>
        text && text.length === 17 ? (
          <a href={"tel:+" + text}>{text}</a>
        ) : (
          "Invalid US Number"
        ),
    },
  ];

  broker_columns = [
    {
      title: "First Name",
      dataIndex: "first_Name",
      sorter: (a, b) => a.first_Name.localeCompare(b.first_Name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Middle Name",
      dataIndex: "middle_Name",
      sorter: (a, b) => {
        a = a.middle_Name || "";
        b = b.middle_Name || "";
        return a.localeCompare(b);
      },
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Last Name",
      dataIndex: "last_Name",
      sorter: (a, b) => a.last_Name.localeCompare(b.last_Name),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      sortDirections: ["descend", "ascend"],
    },
  ];

  ApproveDocumentDefaultHandler = (data, states) => {
    if (states) {
      this.setState({ doc_id: data.id });
    }
    this.setState({ ApproveDocumentActive: !this.state.ApproveDocumentActive });
  };
  changeDocumentStatus = (docdata, status) => {
    this.api.invoke(
      "ApproveOrRejectUserDoc",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            if (status) {
              this.setState({
                ApproveDocumentActive: !this.state.ApproveDocumentActive,
              });
            }
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addDocumentActive: false });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
          this.GetAllUserandhisCompliance();
        } else {
          message.destroy();
          message.error("Add document failed. Contact Support", 3);
        }
      },
      {
        role: this.state.usertype,
        id: docdata.id,
        isApprove: status,
        termination_date: status ? docdata.termination_date : null,
        renewal_date: status ? docdata.renewal_date : null,
      }
    );
  };
  handleClick = (e) => {
    this.setState({
      currentTab: e.key,
    });
  };
  constructor(props) {
    super(props);
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "bsu admin" || role === "carrier" || role === "agency") {
      this.DOCUMENT_COLUMNS.push({
        title: "Action",
        dataIndex: "url",
        width: 50,
        render: (text, record) => {
          return (
            <div style={{ display: "flex" }}>
              <>
                <i
                  style={{ marginTop: "10px" }}
                  onClick={() => window.open(record["document_path"], "_blank")}
                  className="fa fa-eye fa-b"
                />

                <i
                  style={{ marginTop: "10px", marginBottom: "-5px" }}
                  disabled={
                    record["status"] === "Approved" ||
                    record["status"] === "Rejected"
                  }
                  onClick={() =>
                    this.ApproveDocumentDefaultHandler(record, true)
                  }
                  className={"fa fa-check-square-o fa-green"}
                />
                <i
                  style={{ marginTop: "10px" }}
                  disabled={
                    record["status"] === "Approved" ||
                    record["status"] === "Rejected"
                  }
                  onClick={this.changeDocumentStatus.bind(this, record, false)}
                  className="fa fa-ban fa-red"
                />
              </>
            </div>
          );
        },
      });
    }
    this.state = {
      isLoading: true,
      defaultActiveKey: 1,
      usertype: "broker",
      filterTable: null,
      brokers: [],
      agencys: [],
      unserWriter: [],
      currentTab: "doc",
      settings: [],
      isNIPRReqallowed: false,
      rowData: false,
      doc_id: 0,
      ApproveDocumentActive: false,
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {
    this.GetAllUserandhisCompliance();
  }
  onChange = (e) => {
    this.setState({
      usertype: e.target.value,
    });
  };

  search = (value) => {
    if (value.target.value.length > 1) {
      if (this.state.usertype === "broker") {
        this.setState({
          filterTable: this.state.brokers.filter((o) =>
            Object.keys(o).some((k) =>
              String(o[k])
                .toLowerCase()
                .includes(value.target.value.toLowerCase())
            )
          ),
        });
      } else {
        this.setState({
          filterTable: this.state.agencys.filter((o) =>
            Object.keys(o).some((k) =>
              String(o[k])
                .toLowerCase()
                .includes(value.target.value.toLowerCase())
            )
          ),
        });
      }
    } else {
      this.setState({
        filterTable: null,
      });
    }
  };
  GetAllUserandhisCompliance = () => {
    this.setState({ isLoading: true });
    this.api.invoke("GetAllUserandhisCompliance", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            brokers: data.data.broker,
            agencys: data.data.agency,
          });
          this.setState({ isLoading: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };

  render() {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    return (
      <Content>
        {this.state.ApproveDocumentActive ? (
          <Modal visible={this.state.ApproveDocumentActive}>
            <ApproveDocumentDrawer
              closeDrawerHandler={this.ApproveDocumentDefaultHandler}
              submitHandler={this.changeDocumentStatus}
              width={500}
              userPermandMasters={this.props.userPermandMasters}
              title="Approve Document"
              id={this.state.doc_id}
            />
          </Modal>
        ) : null}
        <div className="mi_main_div " style={{ paddingLeft: "10px" }}>
          <Row style={{ marginBottom: "0px" }}>
            <Col span={12}>
              <p className="mi_table_title">Compliance</p>
            </Col>
            <Col span={12}>
              {role === "carrier" || role === "bsu admin" ? (
                <Radio.Group
                  style={{
                    float: "right",
                    marginTop: "8px",
                    marginLeft: "20px",
                    marginRight: "-5px",
                  }}
                  onChange={this.onChange}
                  value={this.state.usertype}
                >
                  <Radio className="micompradio" value="broker">
                    Broker
                  </Radio>
                  <Radio className="micompradio" value="agency">
                    Agency
                  </Radio>
                </Radio.Group>
              ) : (
                ""
              )}
              <Input.Search
                style={{ marginRight: "10px" }}
                className="table-search-button"
                placeholder="Search by Name / Email"
                onChange={this.search.bind(this)}
              />
            </Col>
          </Row>
          <Row style={{ marginRight: "12px" }}>
            <Col span={24}>
              {this.state.usertype === "broker" ? (
                <TableWrapper
                  rowKey="id"
                  locale={{
                    emptyText: (
                      <b style={{ fontSize: "22px" }}>No Pending Approvals</b>
                    ),
                  }}
                  expandedRowRender={(record) => (
                    <Row
                      span={18}
                      style={{ marginLeft: "-30px", marginRight: "26px" }}
                    >
                      {record.docsObjs && record.docsObjs.length > 0 ? (
                        <TableWrapper
                          rowKey="id"
                          title="Documents"
                          columns={this.DOCUMENT_COLUMNS}
                          data={record.docsObjs}
                        />
                      ) : (
                        ""
                      )}

                      {record.licence_Exps && record.licence_Exps.length > 0 ? (
                        <TableWrapper
                          rowKey="id"
                          title="Compliance Expiration(Next 30 Days)"
                          columns={this.com_columns}
                          data={record.licence_Exps}
                        />
                      ) : (
                        ""
                      )}
                    </Row>
                  )}
                  columns={this.broker_columns}
                  data={
                    this.state.isLoading
                      ? null
                      : this.state.filterTable === null
                      ? this.state.brokers
                      : this.state.filterTable
                  }
                  loading={this.state.isLoading}
                />
              ) : (
                <TableWrapper
                  rowKey="id"
                  locale={{
                    emptyText: (
                      <b style={{ fontSize: "22px" }}>No Pending Approvals</b>
                    ),
                  }}
                  expandedRowRender={(record) => (
                    <Row
                      span={18}
                      style={{ marginLeft: "-30px", marginRight: "26px" }}
                    >
                      {record.docsObjs && record.docsObjs.length > 0 ? (
                        <TableWrapper
                          rowKey="id"
                          title="Documents"
                          columns={this.DOCUMENT_COLUMNS}
                          data={record.docsObjs}
                        />
                      ) : (
                        ""
                      )}
                      {record.licence_Exps && record.licence_Exps.length > 0 ? (
                        <TableWrapper
                          rowKey="id"
                          title="Compliance Expiration(Next 30 Days)"
                          columns={this.com_columns}
                          data={record.licence_Exps}
                        />
                      ) : (
                        ""
                      )}
                    </Row>
                  )}
                  columns={this.agency_columns}
                  data={
                    this.state.isLoading
                      ? null
                      : this.state.filterTable === null
                      ? this.state.agencys
                      : this.state.filterTable
                  }
                  loading={this.state.isLoading}
                />
              )}
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}
export default Compliance;
